var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "garant-part" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-lg-10" }, [
            _c("div", { staticClass: "garant-list" }, [
              _c("div", { staticClass: "garant_item" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../img/header/shield.svg"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "min" }, [
                  _vm._v("Elbyte med prisgaranti")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "garant_item" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../img/header/scales.svg"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "min" }, [
                  _vm._v("Jämför och byt gratis")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "garant_item" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../img/header/calendar.svg"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "min" }, [_vm._v("14 dagars ångerrätt")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "garant_item big-item" }, [
                _c("img", {
                  attrs: { src: require("../../../../img/candel.svg"), alt: "" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "min" }, [
                  _vm._v("A switch never causes any power failure")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "garant_item big-item" }, [
                _c("img", {
                  attrs: { src: require("../../../../img/cash2.svg"), alt: "" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "min" }, [
                  _vm._v("In average our customers save 2000 Kr/year")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }